import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DatepickerServiceService {
  that: any;
  tag_name = '';
  date = new Date();
  indexForm: any;

  constructor() {
  }

  initDatePicker(that, defaultDay = 1) {
    const old_form: any = JSON.parse(localStorage.getItem(that.tag_name));
    this.that = that;

    if (old_form) {
      const firstDayOfMonth = new Date(old_form.byear0, old_form.bmonth0 - 1, old_form.bday0);
      const end_date = new Date(old_form.byear1, old_form.bmonth1 - 1, old_form.bday1);
      that.selectedMoments = [firstDayOfMonth, end_date];
    } else {
      if (defaultDay !== 1) {
        defaultDay = this.date.getDate() + defaultDay;
      }
      const firstDayOfMonth = new Date(this.date.getFullYear(), this.date.getMonth(), defaultDay);
      that.selectedMoments = [firstDayOfMonth, new Date()];
    }

    // Set form
    const d = that.selectedMoments;
    that.form['bday0'] = d[0].getDate();
    that.form['bmonth0'] = d[0].getMonth() + 1;
    that.form['byear0'] = d[0].getFullYear();

    that.form['bday1'] = d[1].getDate();
    that.form['bmonth1'] = d[1].getMonth() + 1;
    that.form['byear1'] = d[1].getFullYear();

    console.log('form content', that.form);
  }

  onDAteTimeChange(index, that) {
    // console.log("form", that.form);
    // return true;
    const alter_index = index === 1 ? 0 : 1;
    console.log('selected date ', that.selectedMoments, typeof that.selectedMoments[index]);
    // const d = new Date(dt.selected);
    const d = new Date(that.selectedMoments[index]);
    d.setMinutes(d.getMinutes() + 480);
    console.log('ok changing....', d);
    console.log('Y-M-D', d.getFullYear() + '-' + d.getMonth() + '-' +
      d.getDate());

    that.form['bday' + index] = d.getDate();
    that.form['bmonth' + index] = d.getMonth() + 1;
    that.form['byear' + index] = d.getFullYear();

    if (that.selectedMoments[alter_index] == null) {
      that.selectedMoments[alter_index] = that.selectedMoments[index];
      console.log('alter index ' + alter_index, that.selectedMoments[alter_index]);
      this.onDAteTimeChange(alter_index, that);
      return true;
    } else {
      localStorage.setItem(that.tag_name, JSON.stringify(that.form));
      that.urlingo = JSON.stringify(that.form);
    }

    console.log(that.form);
  }
}
